import React, {Component} from 'react';
import { AxlLoading } from 'axl-reactjs-ui';

import * as E from './styles';
import { lightTheme } from '../../themes';

export class LoadingOverlay extends Component {
  render() {
    const {color} = this.props;

    return (
      <E.Container>
        <E.Loading>
          <AxlLoading color={color || lightTheme.palette.primary.main}/>
        </E.Loading>
      </E.Container>
    )
  }
}